import {
  Box,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Input,
  VStack,
} from '@chakra-ui/react'
import { useForm } from 'react-hook-form'
import { isAddress } from 'viem'

export const AddConsumerForm = ({ onSubmit, setShowAddConsumer }) => {
  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting },
  } = useForm()

  return (
    <Box w={['auto', 'sm', 'md']}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <VStack align={'center'}>
          <FormControl isInvalid={errors.address}>
            <FormLabel mb={0} htmlFor="address" fontSize={'small'}>
              Add consumer (address)
            </FormLabel>
            <HStack flexDir={['column', 'row']} alignItems={'center'}>
              <Input
                borderColor={'primary.100'}
                id="address"
                {...register('address', {
                  required: 'This is required',
                  pattern: {
                    value: /^(0x)?[0-9a-fA-F]{40}$/,
                    message: 'Please enter a valid address',
                  },
                  validate: {
                    isValidAddress: (value) =>
                      isAddress(value) || 'Please enter a valid address',
                  },
                })}
              />
              <HStack>
                <Button isLoading={isSubmitting} type="submit">
                  Submit
                </Button>
                <Button
                  disabled
                  onClick={() => setShowAddConsumer(false)}
                  variant={'outline'}
                >
                  Cancel
                </Button>
              </HStack>
            </HStack>
            <FormErrorMessage>
              {errors.address && errors.address.message}
            </FormErrorMessage>
          </FormControl>
        </VStack>
      </form>
    </Box>
  )
}
